import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconDragHandleStyle0 = gravityIconIndividualCss;

const GravityIconDragHandle = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '9e41c403561aa9ad62da780ce8073114cc7113f5', color: this.color, size: this.size }, h("svg", { key: '0ac011e642d198b60f3b786bc15af77dcd268916', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '288198c54ff4f1f130b4b635d4ade5705dbc939a', d: "M3.5 8a.5.5 0 0 0-.5.5V9a.5.5 0 0 0 .5.5h15A.5.5 0 0 0 19 9v-.5a.5.5 0 0 0-.5-.5h-15Zm0 5.25a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-15Z", fill: "currentColor" }))));
    }
};
GravityIconDragHandle.style = GravityIconDragHandleStyle0;

export { GravityIconDragHandle as gravity_icon_drag_handle };

//# sourceMappingURL=gravity-icon-drag-handle.entry.js.map